import { Box, IconButton, Tooltip } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomizedDataGrid from "../../customized-data-grid/customized-data-grid";
import { FolderSummary } from "../types";
import { formatDate, formatFileSize } from "../utils/formatters";
import { STATISTICS_PLACEHOLDER, hasStatistics } from "../utils/folder-summary";

interface FolderListTableProps {
  folders: FolderSummary[];
  onViewFolder: (folder: FolderSummary) => void;
}

const FolderListTable = ({ folders, onViewFolder }: FolderListTableProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleCellClick = (params: any) => {
    if (params.field !== "actions") {
      onViewFolder(params.row);
    }
  };

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Folder Name",
      flex: 2,
      minWidth: 250,
    },
    {
      field: "fileCount",
      headerName: "Files",
      flex: 0.6,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      valueFormatter: (value) => value ?? STATISTICS_PLACEHOLDER,
    },
    {
      field: "totalSize",
      headerName: "Total Size",
      flex: 1,
      minWidth: 120,
      valueFormatter: (value) =>
        value === null ? STATISTICS_PLACEHOLDER : formatFileSize(value),
    },
    {
      field: "archivedCount",
      headerName: "Archived",
      flex: 0.6,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      valueFormatter: (value) => value ?? STATISTICS_PLACEHOLDER,
    },
    {
      field: "lastModifiedOn",
      headerName: "Last Modified",
      flex: 1,
      minWidth: 160,
      valueFormatter: (value, row: FolderSummary) =>
        hasStatistics(row) ? formatDate(value) : STATISTICS_PLACEHOLDER,
    },
    {
      field: "calculatedOn",
      headerName: "Statistics As Of",
      flex: 1,
      minWidth: 160,
      valueFormatter: (value) =>
        value ? formatDate(value) : "Open to calculate",
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      flex: 0.6,
      minWidth: 100,
      headerAlign: "right",
      align: "right",
      renderCell: (params: GridRenderCellParams<FolderSummary>) => (
        <Tooltip title="View Files">
          <IconButton
            size="small"
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              onViewFolder(params.row);
            }}
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <CustomizedDataGrid
        data={folders}
        columns={columns}
        isLoading={false}
        initialSortingField="name"
        rowSelection
        getRowId={(row) => row.name}
        type="folder"
        onCellClick={handleCellClick}
        height={635}
      />
    </Box>
  );
};

export default FolderListTable;
